import { ChangeEvent, useState } from "react";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../Context/Historico";
import { useUserInfor } from "../../../../Context/User";
import { CadastrarHistoricosController } from "../../../../Controllers/Cobranca/GestaoAtendimento/HistoricosControllers";
import { FroalaEditor } from "../../Forms/Editor/FroalaEditor";
import { Switch } from "../../Forms/Switch";
import { Spinner } from "../../../Loding/SpinnerPadrao";
import { IListarCasoResponse } from "../../../../Interfaces/Vendas/Caso/CasoInterface";

interface ModalCadastrarPropsInterface {
    setShow: (show: boolean) => void;
    caso?: IListarCasoResponse;
    updateList?: (...args: any[]) => Promise<IListarCasoResponse[]>;
}

export default function CadastrarHistorico(
    this: any,
    props: ModalCadastrarPropsInterface
) {
    const { Atendimento } = useAtendimentoPage();
    const { ReloadHistorico, cadastrarHistoricoRef } = useHistoricoContext();

    const userId = useUserInfor().UserInfor.ID_USUARIO;
    const [uploading, setUploading] = useState(0);
    const [loading, setLoading] = useState(false);
    const [uploadedImages, setUploadedImages] = useState<string[]>([]);

    const [historicoHTML, setHistoricoHTML] = useState(
        (Atendimento?.ID_CASO ? cadastrarHistoricoRef.current : "") ?? ""
    );

    const [Selecionado, setSelecionado] = useState(false);

    const onSubmit = () => {
        if (userId && historicoHTML) {
            // Mapeia o html e substitui o src pelo link que é armazenado no state uploadedImages de forma dinamica
            let modifiedHistoricoHTML = historicoHTML;
            const imagesToReplace =
                modifiedHistoricoHTML.match(
                    /<img[^>]*src="blob[^"]*"[^>]*>/g
                ) || [];

            imagesToReplace.forEach((imageTag) => {
                const uploadedImageUrl = uploadedImages.shift() || "";
                modifiedHistoricoHTML = modifiedHistoricoHTML.replace(
                    /<img[^>]*src="blob[^"]*"[^>]*>/,
                    imageTag.replace(
                        /src="blob[^"]*"/,
                        `src="${uploadedImageUrl}"`
                    )
                );
            });

            setLoading(true);

            CadastrarHistoricosController({
                DS_HISTORICO: modifiedHistoricoHTML,
                DT_CADASTRO: new Date().toISOString(),
                ID_CASO: Atendimento?.ID_CASO
                    ? Atendimento?.ID_CASO
                    : props.caso?.ID_CASO ?? 0,
                ID_USUARIO: userId,
                ID_CASO_HISTORICO: 0,
                ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                    Atendimento?.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO ?? 0,
                ID_ETAPA_TIPO_CASO: Atendimento?.ID_ETAPA_TIPO_CASO
                    ? Atendimento?.ID_ETAPA_TIPO_CASO
                    : props.caso?.ID_ETAPA_TIPO_CASO,
                FL_CLIENTE_VISUALIZA_HISTORICO: Selecionado,
            }).then((res) => {
                props.setShow(false);
                setHistoricoHTML("");
                if (props.updateList) {
                    props.updateList();
                }
                if (Atendimento?.ID_CASO) {
                    cadastrarHistoricoRef.current = undefined;
                    ReloadHistorico();
                }
                setLoading(false);
            });
        }
    };
    function handleChange(e: ChangeEvent<HTMLInputElement>) {
        setSelecionado(e.target.checked);
    }

    return (
        <>
            <div className="text-center mb-lg-5">
                <h2 className="font-weight-bold">Cadastro de Histórico</h2>
            </div>

            {uploading > 0 && ( 
                <div className="d-flex align-items-center justify-content-center g-2 p-2">
                Fazendo upload de imagem{" "}
                <Spinner size="sm" color="primary" />
                </div>
            )}

            {loading && (
                <div className="d-flex align-items-center justify-content-center g-2 p-2">
                    Salvando histórico <Spinner size="sm" color="primary" />
                </div>
            )}

            <FroalaEditor
                onChange={(value) => {
                    setHistoricoHTML(value);
                    if (Atendimento?.ID_CASO)
                        cadastrarHistoricoRef.current = value;
                }}
                value={historicoHTML}
                onImageUploadStart={() => setUploading((prev) => prev + 1)}
                onImageUploadEnd={() => setUploading((prev) => prev - 1)}
                setUploadedImages={setUploadedImages}
            />

            {/* <Editor
                onChange={(value) => {
                    setHistoricoHTML(value);
                    cadastrarHistoricoRef.current = value;
                }}
                idCaso={Atendimento?.ID_CASO}
                onImageUploadStart={() => setUploading(true)}
                onImageUploadEnd={() => setUploading(false)}
                value={historicoHTML}
                placeholder="Descrição"
            /> */}
            <Switch
                label="Cliente visualiza"
                type="checkbox"
                color="success"
                swicthSize="sm"
                checked={Selecionado}
                onChange={handleChange}
            />
            <div className="d-flex flex-wrap justify-content-center align-items-center lg-5 mt-1">
                <button
                    type="submit"
                    disabled={!historicoHTML?.length || uploading > 0 || loading}
                    className="btn btn-capys font-weight-bold"
                    onClick={onSubmit}
                >
                    Cadastrar
                </button>
            </div>
        </>
    );
}
